export default __webpack_public_path__ + "static/1617-2f20769e6fb303c70438c93f77bba109.gif";